import Vue from "vue";

export default {
    data() {
        return {
            mobileMenu: {
                switchBody: true
            },
            sections: [
                {
                    name: Vue.prototype.$lang('header.page'),
                    href: '/page',
                    icon: 'icon-pages',
                    isShowIcon: true,
                    isBurgerMenu: false,
                    pages: [
                        {
                            href: '/page#sharing-memories-easy',
                            name: Vue.prototype.$lang('app.menu.how_it_works')
                        },
                        {
                            href: '/page#pages-examples',
                            name: Vue.prototype.$lang('app.menu.view')
                        },
                        {
                            href: '/page/faq',
                            name: Vue.prototype.$lang('app.menu.q_a')
                        },
                        {
                            href: '/page/services',
                            name: Vue.prototype.$lang('app.menu.services')
                        },
                        {
                            href: this.createPageLink(),
                            name: Vue.prototype.$lang('preview.button'),
                            button: true,
                        },
                    ],
                    active: false,
                },
                // {
                //     name: Vue.prototype.$lang('header.memories'),
                //     href: '/memories',
                //     icon: 'icon-heart',
                //     pages: [
                //         {
                //             href: '/memories#info',
                //             name: Vue.prototype.$lang('sections.memories.nav.histories')
                //         },
                //         {
                //             href: '/memories#moments',
                //             name: Vue.prototype.$lang('sections.memories.nav.moments')
                //         },
                //         {
                //             href: '/memories/redirect',
                //             name: Vue.prototype.$lang('MiniProfile.myProfile'),
                //             auth: true,
                //             visible: true,
                //             button: true,
                //         },
                //     ],
                //     active: false,
                // },
                {
                    name: Vue.prototype.$lang('header.place'),
                    href: '/place',
                    icon: 'icon-places',
                    isShowIcon: true,
                    isBurgerMenu: false,
                    pages: [
                        {
                            href: '/place#benefit',
                            name: Vue.prototype.$lang('sections.place.nav.benefit')
                        },
                        {
                            href: '/place#examples',
                            visible: window.laravel.locale === 'ru',
                            name: Vue.prototype.$lang('sections.place.nav.examples')
                        },
                        {
                            href: '/place#why',
                            name: Vue.prototype.$lang('sections.place.nav.advantages')
                        },
                    ],
                    active: false,
                },
                {
                    name: Vue.prototype.$lang('header.familytree'),
                    href: '/familytree',
                    icon: 'icon-tree',
                    isShowIcon: true,
                    isBurgerMenu: false,
                    pages: [
                        {
                            href: '/familytree#romanov',
                            name:  Vue.prototype.$lang('MobileMenu.romanov.menu')
                        },
                        {
                            href: '/familytree#advantages',
                            name: Vue.prototype.$lang('MobileMenu.advantages')
                        },
                        {
                            href: '/familytree#create-tree',
                            name: Vue.prototype.$lang('MobileMenu.create.ft.menu')
                        },
                        {
                            href: '/page/prices?isSubscriptionSelected=1',
                            name: Vue.prototype.$lang('MobileMenu.subscribe.menu')
                        },
                        {
                            href: '/familytree#faq',
                            name: Vue.prototype.$lang('MobileMenu.faq.title')
                        },
                        {
                            href: window.laravel.user
                                ? '/cabinet/tree'
                                : this.$router.resolve({name: 'login', query: {redirect: '/cabinet/tree'}}).href,
                            name: window.laravel.user
                                ? Vue.prototype.$lang('MobileMenu.mine.ft')
                                : Vue.prototype.$lang('MobileMenu.create.ft'),
                            button: true,
                        },
                    ],
                    active: false,
                },
                {
                    name: Vue.prototype.$lang('header.about'),
                    href: '/about-service',
                    isShowIcon: false,
                    isBurgerMenu: false,
                    active: false,
                    pages: [],
                },
                {
                    name: Vue.prototype.$lang('header.page'),
                    href: '/page',
                    icon: 'icon-pages',
                    isBurgerMenu: true,
                    pages: [
                        {
                            href: '/',
                            name: Vue.prototype.$lang('header.main')
                        },
                        {
                            href: '/page/prices',
                            name: Vue.prototype.$lang('app.menu.prices')
                        },
                        {
                            href: '/news',
                            name: Vue.prototype.$lang('app.menu.news')
                        },
                        {
                            href: '/articles',
                            name: Vue.prototype.$lang('app.menu.articles')
                        },
                        {
                            href: '/contacts#support',
                            name: Vue.prototype.$lang('app.menu.contacts')
                        },
                    ],
                    active: false,
                },
            ],
        }
    },
    mounted() {
        this.currentSectionActive();
    },
    methods: {
        showSection(section) {
            let active = section.active;

            this.sections.forEach(section => section.active = false);

            section.active = !active;
        },
        showProfile() {
            this.mobileMenu.switchBody = false;

            this.$refs.mobileMenu.show();
        },
        currentSectionActive() {
            if (this.$route.path === '/') {
                return
            }

            this.mobileMenu.switchBody = true;

            this.sections.forEach(item => item.active = false);

            const currentSection = this.sections.find(item => {
                if (item.href === this.$route.path) {
                    return item
                }

                return item.pages.some(page => page.href === this.$route.path)
            });

            if (!!currentSection) {
                currentSection.active = true;
            }
        },
        createPageLink () {
            if (window.laravel.isAdmin || window.laravel.isMaster || window.laravel.isPartner) {
                return '/cabinet/page/add'
            }
            return '/create/tariffs'
        }
    }

}
